import $ from "jquery"; // Import jQuery
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import useFocusedRowHighlight from "../../../../../hooks/useFocusedRowHighlight";
import Http from "../../../../Common/Http";
import IsLogin from "../../../../Common/IsLogin";
import { LoaderComponent } from "../../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const Create = () => {
  const { checkRequiredFields } = useRequiredFields();
  const { getRowProps } = useFocusedRowHighlight();
  const navigate = useNavigate();
  const [searchProducts, setSearchProducts] = useState("");
  const [originalList, setOriginalList] = useState([]);
  const [showPagination, setShowPagination] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const { id } = useParams();

  const [inputs, setInputs] = useState({
    receipt_no: "",
    production_work_order_id: "",
    date: "",
    receive_date: "",
    entry_date: new Date().toISOString().split("T")[0],
    copy_type: "",
    purchase_type: "",
    from_department: "",
    to_department: "",
    status: "requested",
    // remarks: "",
  });
  const [loading, setLoading] = useState(false);

  const [list, setList] = useState([]);
  const [error, setError] = useState({});
  // const [product, setProduct] = useState([]);
  const [planningOptions, setPlanningOptions] = useState([]);
  const [role, setRole] = useState("");
  const [itemLoading, setItemLoading] = useState(false);
  const [departments, setDepartments] = useState([
    { id: 1, name: "BODY", user_type: "body" },
    { id: 2, name: "JIGGER", user_type: "jigger" },
    { id: 3, name: "CASTING", user_type: "casting" },
    { id: 4, name: "FINISHING", user_type: "finishing" },
    { id: 5, name: "BK", user_type: "bk" },
    { id: 6, name: "GLAZING", user_type: "glazing" },
    { id: 7, name: "GK", user_type: "gk" },
    { id: 8, name: "SELECTION", user_type: "selection" },
    { id: 9, name: "DECORATION LOCAL", user_type: "decoration_local" },
    { id: 10, name: "DECORATION EXPORT", user_type: "decoration_export" },
    { id: 11, name: "DFW", user_type: "dfw" },
    { id: 12, name: "PACKING LOCAL", user_type: "packing_local" },
    { id: 13, name: "PACKING EXPORT", user_type: "packing_export" },
    { id: 14, name: "DSTORE", user_type: "dstore" },
    { id: 15, name: "GSTORE", user_type: "gstore" },
    { id: 16, name: "MOULD", user_type: "mould" },
    { id: 17, name: "PSTORE", user_type: "pstore" },
    { id: 18, name: "PLANNING", user_type: "planning" },
    { id: 19, name: "SAGGER", user_type: "sagger" },
  ]);

  const defectTypes = [
    "BN",
    "IS",
    "PH",
    "GD",
    "UG",
    "SS",
    "CR",
    "HC",
    "DC",
    "ST",
    "UD",
    "LT",
    "BC",
    "KD",
    "FD",
    "RC",
    "AIR",
  ];
  const [allItemsWithInput, setAllItemsWithInput] = useState(new Map());

  // Reference to store search timeout
  const searchTimeoutRef = useRef(null);

  const repairTypes = ["PH", "SS", "AIR", "HC"];
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 15,
    total: 0,
    last_page: 1,
  });

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      // const resProduct = await Http.get("/product-list/all");
      // setProduct(resProduct.data);

      const resRole = await Http.get("/staff-type-check");
      setRole(resRole.data);

      const resPlanning = await Http.get("/planning");
      const planningData = resPlanning.data;
      setPlanningOptions(planningData);

      if (planningData.length > 0) {
        // Automatically select the first planning and set in inputs
        const firstPlanning = planningData[0];
        setInputs((prevInputs) => ({
          ...prevInputs,
          planning_id: firstPlanning.id, // Assuming the ID field for planning
        }));

        // Load items for the first planning
        handlePlanningChange(firstPlanning.id);
      }

      // Fetch the receipt number
      const resReceiptNo = await Http.get(
        "/last-code-increment-by-one/production_finished_goods/receipt_no/FG",
      );
      const receiptNo = resReceiptNo.data; // Assuming the API returns the receipt number directly

      // Set the fetched receipt number to inputs
      setInputs((prevInputs) => ({
        ...prevInputs,
        receipt_no: receiptNo,
      }));
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  useEffect(() => {
    $("body").addClass("collapse-menu");
    // $("body").toggleClass("show-left");
    fetchData();
  }, []);

  const handlePlanningChange = async (planningId, page = 1) => {
    // Always set loading states when planning changes
    setLoading(true);
    setItemLoading(true);

    if (!planningId) {
      setLoading(false);
      setItemLoading(false);
      return;
    }

    // Show pagination when using handlePlanningChange
    setShowPagination(true);

    setInputs((prevInputs) => ({
      ...prevInputs,
      planning_id: planningId, // Update planning_id in inputs
    }));

    try {
      // Fetch data based on selected planning ID
      const response = await Http.get(
        `/planning/${planningId}?page=${page}&limit=${pagination.per_page}`,
      );

      // Update list with items from the response
      const planningItems = response.data.items.map((item) => {
        // Check if this specific item (by ID) already has user input
        const existingItem = allItemsWithInput.get(item.id);
        const initialAvailableQty =
          (parseFloat(item?.current_stock) || 0);

        const baseItem = {
          id: item?.id,
          product_id: item?.product_id,
          shape_id: item?.shape_id,
          glaze_id: item?.glaze_id,
          decoration_code: item?.decoration_code,
          decoration_name: item?.decoration_name,
          product_name: item?.product?.name,
          shape: item?.shape?.name,
          production_work_order: item?.production_work_order?.receipt_no,
          company: item?.production_work_order?.company?.name,
          product_code: item?.product?.code,
          opening_balance: 0,
          weight: item.weight,
          production_qty: 0,
          glaze_color_name:
            item?.production_work_order_item?.color?.colour_name,
          qty_export: 0,
          qty_a_class: 0,
          qty_b_class: 0,
          qty_c_class: 0,
          transfer_qty: 0,
          closing_balance: item?.qty,
          remarks_delivery: "",
          qty: item.qty,
          total_received_qty: item?.total_received_qty,
          total_transfer_qty: item?.total_transfer_qty,
          total_selcted_qty: item?.total_selcted_qty,
          total_repair_qty: item?.total_repair_qty,
          total_defect_qty: item?.total_defect_qty,
          initial_available_qty: initialAvailableQty,
          available_qty: initialAvailableQty,
          select_qty: 0, // Initialize to 0
          defect_items: [], // Initialize as empty array
          repair_items: [], // Initialize as empty array
          status: item?.production_work_order?.status,
          current_stock: item?.current_stock,
          current_stock_qty_export_class: item?.current_stock_qty_export_class,
          current_stock_qty_a_class: item?.current_stock_qty_a_class,
          current_stock_qty_b_class: item?.current_stock_qty_b_class,
          current_stock_qty_c_class: item?.current_stock_qty_c_class,
        };

        return existingItem ? { ...baseItem, ...existingItem } : baseItem;
      });

      setList(planningItems);
      setOriginalList(planningItems);
      setPagination(response.data.pagination);

      // Update the global map with new items (only if they don't already exist)
      setAllItemsWithInput((prevMap) => {
        const newMap = new Map(prevMap);
        planningItems.forEach((item) => {
          if (!newMap.has(item.id)) {
            newMap.set(item.id, item);
          }
        });
        return newMap;
      });
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning.",
        "error",
      );
    } finally {
      setLoading(false);
      setItemLoading(false);
    }
  };

  // Update the handleAddType function to recalculate select_qty when a repair item is added
  const handleAddType = (index, type) => {
    const updatedList = [...list];
    const productId = updatedList[index]?.product_id; // Get product ID from list
    const shapeId = updatedList[index]?.shape_id;
    const glazeId = updatedList[index]?.glaze_id;
    const decorationCode = updatedList[index]?.decoration_code;
    const decorationName = updatedList[index]?.decoration_name;

    if (!productId) {
      console.error("Product ID is missing for index:", index);
      return;
    }
    const newEntry = {
      product_id: productId,
      shape_id: shapeId,
      glaze_id: glazeId,
      decoration_code: decorationCode,
      decoration_name: decorationName,
      type: "",
      qty: 0,
    };

    if (type === "defect") {
      updatedList[index].defect_items = [
        ...(updatedList[index].defect_items || []),
        newEntry,
      ];
    } else if (type === "repair") {
      updatedList[index].repair_items = [
        ...(updatedList[index].repair_items || []),
        newEntry,
      ];
    }

    // No need to recalculate select_qty here as the new entry has qty 0

    setList(updatedList);
    setOriginalList(updatedList);

    // ← ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  const handleTypeChange = (index, subIndex, value, type) => {
    const updatedList = [...list];
    if (type === "defect") {
      updatedList[index].defect_items[subIndex].type = value;
    } else if (type === "repair") {
      updatedList[index].repair_items[subIndex].type = value;
    }
    setList(updatedList);
    setOriginalList(updatedList);

    // ← ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Helper function to calculate total select quantity including all sources
  const calculateTotalSelectQty = (item) => {
    // Sum of all class quantities
    const classQty =
      (parseFloat(item.qty_export) || 0) +
      (parseFloat(item.qty_a_class) || 0) +
      (parseFloat(item.qty_b_class) || 0) +
      (parseFloat(item.qty_c_class) || 0);

    // Sum of all repair quantities
    const repairQty = (item.repair_items || []).reduce(
      (sum, repairItem) => sum + (parseFloat(repairItem.qty) || 0),
      0,
    );

    return classQty + repairQty;
  };

  const calculateMaxSelectableQty = (item) => {
    if (
      item?.initial_available_qty !== undefined &&
      item?.initial_available_qty !== null
    ) {
      return parseFloat(item.initial_available_qty) || 0;
    }

    const currentStock = parseFloat(item.current_stock) || 0;
    const totalSelected = parseFloat(item.total_selcted_qty) || 0;
    const totalRepair = parseFloat(item.total_repair_qty) || 0;

    return currentStock - totalSelected - totalRepair;
  };

  // Add a new helper function to calculate available quantity
  const calculateAvailableQty = (item) => {
    const maxSelectableQty = calculateMaxSelectableQty(item);
    const currentSelectQty = calculateTotalSelectQty(item);
    // return Math.max(0, maxSelectableQty - currentSelectQty);
    return maxSelectableQty - currentSelectQty;
  };

  // Updated handleQtyChange function with proper validation
  const handleQtyChange = (index, subIndex, value, type) => {
    const updatedList = [...list];
    const item = updatedList[index];
    const quantity = parseInt(value) || 0;

    // Store the old quantity for comparison
    const oldQuantity =
      type === "defect"
        ? parseInt(item.defect_items[subIndex].qty) || 0
        : parseInt(item.repair_items[subIndex].qty) || 0;

    // Calculate how much adding this quantity would increase the total
    const quantityDiff = quantity - oldQuantity;

    // Current total select quantity (before this change)
    const currentSelectQty = calculateTotalSelectQty(item);

    // Maximum allowed quantity
    const maxSelectQty = Math.max(0, calculateMaxSelectableQty(item));

    /* artisan er 1st june er stock pawa porjonto eta temporary vabe off thakbe */
    if (currentSelectQty + quantityDiff > maxSelectQty) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: `Total selected quantity cannot exceed ${maxSelectQty}. Currently selected: ${currentSelectQty}`,
      });
      return;
    }
    //  */

    // Update the quantity
    if (type === "defect") {
      updatedList[index].defect_items[subIndex].qty = quantity;
      // Calculate total defect quantity and set it as qty_c_class
      const totalDefectQty = updatedList[index].defect_items.reduce(
        (sum, item) => sum + (parseInt(item.qty) || 0),
        0,
      );
      updatedList[index].qty_c_class = totalDefectQty;
    } else if (type === "repair") {
      updatedList[index].repair_items[subIndex].qty = quantity;
    }

    // Update the select_qty property
    updatedList[index].select_qty = calculateTotalSelectQty(updatedList[index]);

    // Update available_qty
    if (
      updatedList[index].initial_available_qty === undefined ||
      updatedList[index].initial_available_qty === null
    ) {
      updatedList[index].initial_available_qty = calculateMaxSelectableQty(
        updatedList[index],
      );
    }
    updatedList[index].available_qty = calculateAvailableQty(
      updatedList[index],
    );

    setList(updatedList);
    setOriginalList(updatedList);

    // ← ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  // Updated handleInputChange function with proper validation
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const type = e.target.type;
    const updatedList = [...list];
    const item = updatedList[index];
    // console.log(type);

    // Get the old value before changing
    const oldValue = parseInt(item[name]) || 0;
    // New value to be set
    const newValue = type === "text" ? parseInt(value) || 0 : value;

    // Check if this is a quantity field
    const isQuantityField = [
      "qty_export",
      "qty_a_class",
      "qty_b_class",
      "qty_c_class",
    ].includes(name);

    if (isQuantityField) {
      // Calculate how much this change will affect the total
      const valueDiff = newValue - oldValue;

      // Get current total (before this change)
      const currentTotal = calculateTotalSelectQty(item);

      // Maximum allowed quantity
      const maxSelectQty = Math.max(0, calculateMaxSelectableQty(item));

      // Check if this change would exceed the maximum
      /* artisan er 1st june er stock pawa porjonto eta temporary vabe off thakbe */

      if (currentTotal + valueDiff > maxSelectQty) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: `Total selected quantity cannot exceed ${maxSelectQty}. Currently selected: ${currentTotal}`,
        });

        // Don't update the value
        return;
      }
      // */
    }

    // Update the value
    if (type === "text") {
      updatedList[index][name] = newValue;
    } else {
      updatedList[index][name] = value;
    }

    // If it's a quantity field, recalculate the totals
    if (isQuantityField) {
      // Recalculate select_qty after updating the field
      updatedList[index].select_qty = calculateTotalSelectQty(
        updatedList[index],
      );

      // Update available_qty
      if (
        updatedList[index].initial_available_qty === undefined ||
        updatedList[index].initial_available_qty === null
      ) {
        updatedList[index].initial_available_qty = calculateMaxSelectableQty(
          updatedList[index],
        );
      }
      updatedList[index].available_qty = calculateAvailableQty(
        updatedList[index],
      );
    }

    setList(updatedList);

    // Update the global map with the actual item ID
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
    // setOriginalList(updatedList);
    setOriginalList((prevOriginalList) =>
      prevOriginalList.map((item, idx) =>
        item.id === updatedList[index].id ? { ...updatedList[index] } : item,
      ),
    );
  };

  // Updated handleRemoveType function to recalculate correctly
  const handleRemoveType = (index, subIndex, type) => {
    const updatedList = [...list];
    if (type === "defect") {
      updatedList[index].defect_items.splice(subIndex, 1);
      // Recalculate C class qty after removing defect
      const totalDefectQty = updatedList[index].defect_items.reduce(
        (sum, item) => sum + (parseInt(item.qty) || 0),
        0,
      );
      updatedList[index].qty_c_class = totalDefectQty;
    } else if (type === "repair") {
      updatedList[index].repair_items.splice(subIndex, 1);
    }

    // Recalculate select_qty using our helper function
    updatedList[index].select_qty = calculateTotalSelectQty(updatedList[index]);

    // Update available_qty
    updatedList[index].available_qty = calculateAvailableQty(
      updatedList[index],
    );

    setList(updatedList);
    setOriginalList(updatedList);

    // ← ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  // Ensure handlePlanningChange also initializes repair_items and defect_items properly

  const formSubmit = () => {
    checkRequiredFields();
    const allItemsArray = Array.from(allItemsWithInput.values());

    const formData = {
      ...inputs,
      items: allItemsArray,
    };

    // ADDED: confirmation prompt before submitting
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit this transfer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      // if (!result.isConfirmed) return;
      if (!result.isConfirmed) {
        setIsSubmitting(false); // ADDED: reappear on cancel
        return;
      }

      Http.post(`/production-transfer`, formData)
        .then((res) => {
          navigate("/transfer-art", {
            state: { message: res.data.message, type: "success" },
          });
        })
        // .catch(function (e) {
        //   setError(e.response.data.errors);
        // });
        .catch((e) => {
          const responseData = e.response?.data;
          const errors = responseData?.errors;

          // Stock validation errors come back as a plain array of message strings
          if (Array.isArray(errors) && errors.length > 0) {
            Swal.fire({
              icon: "error",
              title: responseData.message || "Validation Error",
              html: `<ul style="text-align:left; margin:0; padding-left:20px;">
                         ${errors.map((msg) => `<li>${msg}</li>`).join("")}
                       </ul>`,
            });
            return;
          }

          // Fallback: laravel-style field validation errors (object, not array)
          setError(errors || {});
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text:
              responseData?.message ||
              "Something went wrong. Please check the form.",
          });
        });
    });
  };

  const cols = [{ field: "name", header: "Item" }];

  // Define debouncedSearch function using useCallback
  const debouncedSearch = useCallback(
    async (searchValue, page = 1) => {
      try {
        setLoading(true);
        setItemLoading(true);
        const planningId = inputs.planning_id;
        setShowPagination(true);

        if (!searchValue || searchValue.trim() === "") {
          // Restore original list when input is empty
          setShowPagination(true);
          handlePlanningChange(planningId, page);
          return;
        } else {
          // const response = await Http.post(`/search-products`, {
          //   search: searchValue,
          //   planningId: planningId,
          // });
          const response = await Http.get(
            `/planning/${planningId}?page=${page}&limit=${pagination.per_page}&product_name=${searchValue}`,
          );

          const planningItems = response.data.items.map((item) => {
            // Check if this specific item (by ID) already has user input
            const existingItem = allItemsWithInput.get(item.id);
            const initialAvailableQty =
              (parseFloat(item?.current_stock) || 0);

            const baseItem = {
              id: item?.id,
              product_id: item?.product_id,
              shape_id: item?.shape_id,
              glaze_id: item?.production_work_order_item?.glaze?.id,
              decoration_code:
                item?.production_work_order_item?.decoration_code,
              decoration_name:
                item?.production_work_order_item?.decoration_name,
              product_name: item?.product?.name,
              shape: item?.shape?.name,
              production_work_order: item?.production_work_order?.receipt_no,
              company: item?.production_work_order?.company?.name,
              product_code: item?.product?.code,
              opening_balance: 0,
              weight: item.weight,
              production_qty: 0,
              glaze_color_name:
                item?.production_work_order_item?.color?.colour_name,
              qty_export: 0,
              qty_a_class: 0,
              qty_b_class: 0,
              qty_c_class: 0,
              transfer_qty: 0,
              closing_balance: item?.qty,
              remarks_delivery: "",
              qty: item.qty,
              total_received_qty: item?.total_received_qty,
              total_transfer_qty: item?.total_transfer_qty,
              total_selcted_qty: item?.total_selcted_qty,
              total_repair_qty: item?.total_repair_qty,
              total_defect_qty: item?.total_defect_qty,
              initial_available_qty: initialAvailableQty,
              available_qty: initialAvailableQty,
              select_qty: 0, // Initialize to 0
              defect_items: [], // Initialize as empty array
              repair_items: [], // Initialize as empty array
              status: item?.production_work_order?.status,
              current_stock: item?.current_stock,
              current_stock_qty_export_class:
                item?.current_stock_qty_export_class,
              current_stock_qty_a_class: item?.current_stock_qty_a_class,
              current_stock_qty_b_class: item?.current_stock_qty_b_class,
              current_stock_qty_c_class: item?.current_stock_qty_c_class,
            };

            return existingItem ? { ...baseItem, ...existingItem } : baseItem;
          });

          setList(planningItems);
          setOriginalList(planningItems);
          setPagination(response.data.pagination);
          setAllItemsWithInput((prevMap) => {
            const newMap = new Map(prevMap);
            planningItems.forEach((item) => {
              if (!newMap.has(item.id)) {
                newMap.set(item.id, item);
              }
            });
            return newMap;
          });
        }
      } catch (error) {
        console.error("Error searching products:", error);
        // Don't show Swal.fire for empty results, just set an empty list
        setList([]);
        setOriginalList([]);
      } finally {
        setLoading(false);
        setItemLoading(false);
      }
    },
    [
      inputs.planning_id,
      allItemsWithInput,
      handlePlanningChange,
      setList,
      setOriginalList,
      setAllItemsWithInput,
      setLoading,
    ],
  );

  // Implement debounced search handler
  const handleSearchProduct = (e, page = 1) => {
    const searchValue = e.target.value;
    setSearchProducts(searchValue);
    setShowPagination(false);

    // Always set loading states to true for any search action, including clearing the search
    setLoading(true);
    setItemLoading(true);

    // Clear any existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!searchValue.trim()) {
      setShowPagination(true);
      handlePlanningChange(inputs.planning_id, page);
      return;
    }

    // Set a new timeout
    searchTimeoutRef.current = setTimeout(() => {
      debouncedSearch(searchValue.trim(), page);
    }, 1000); // 1000ms debounce time for better responsiveness
  };

  // const handlePageChange = (page) => {
  //   if (page < 1 || page > pagination.last_page) return;
  //   handlePlanningChange(inputs.planning_id, page);
  // };

  const handlePageChange = (page) => {
    if (page < 1 || page > pagination.last_page) return;

    const currentSearch = searchProducts?.trim();

    if (currentSearch) {
      // Clear any existing timeout to prevent multiple searches
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      // Call debouncedSearch directly with current search value for pagination
      debouncedSearch(currentSearch, page);
    } else {
      handlePlanningChange(inputs.planning_id, page);
    }
  };

  // Render pagination controls
  const renderPagination = () => {
    const { current_page, last_page } = pagination;
    const pageButtons = [];
    let startPage = Math.max(1, current_page - 2);
    let endPage = Math.min(last_page, startPage + 4);

    // Adjust startPage if less than 5 pages at the end
    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <button
          key={i}
          className={`btn btn-sm mx-1 ${
            i === current_page ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => handlePageChange(i)}
          disabled={i === current_page}
        >
          {i}
        </button>,
      );
    }

    return (
      <div className="d-flex align-items-center justify-content-center my-3">
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(1)}
          disabled={current_page === 1}
        >
          First
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page - 1)}
          disabled={current_page === 1}
        >
          Previous
        </button>
        {pageButtons}
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page + 1)}
          disabled={current_page === last_page}
        >
          Next
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(last_page)}
          disabled={current_page === last_page}
        >
          Last
        </button>
        <span className="mx-2">
          Page {current_page} of {last_page}
        </span>
      </div>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Production</h5>
        </div>
        <div className="am-pagebody  row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-11">
            <h6 className="card-body-title mg-sm-b-30">Production</h6>
            {/* <p>Transfer To Department {inputs.to_department}</p> */}

            <div
              className="row my-1 pt-3 mb-2 fixed-header"
              style={{
                position: "sticky",
                top: "12%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1002",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  disabled
                />
              </div>

              {/* <div className="col-lg">
                <label>Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={inputs.date}
                  disabled
                />
              </div> */}
              <div className="col-lg">
                <label>Planning</label>
                <select
                  className="form-control"
                  value={inputs.planning_id || ""} // Bind to inputs
                  onChange={(e) => handlePlanningChange(e.target.value)}
                >
                  <option value="">Select Planning</option>
                  {planningOptions.map((planning) => (
                    <option key={planning.id} value={planning.id}>
                      {planning.receipt_no}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Shift <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="shift"
                  value={inputs.shift}
                  onChange={handleChange}
                  data-required
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Entry Date <i className="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="entry_date"
                  value={inputs.entry_date}
                  onChange={handleChange}
                  data-required
                />
              </div>
            </div>
            <div
              className="row fixed-header pb-1"
              style={{
                position: "sticky",
                top: "22%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1000",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg my-2 ">
                <label>Search Product</label>
                <input
                  type="search"
                  className="form-control"
                  name="search_product"
                  placeholder="Search Product"
                  onChange={(e) => handleSearchProduct(e)}
                />
              </div>
              {/* <div className="row">
                <label>Transfer To Department {inputs.to_department}</label>
              </div> */}
              <div className="col-lg my-2 ">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={inputs.remarks}
                  onChange={handleChange}
                />
              </div>
              {list?.length > 0 && (
                <>
                  {!isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          setIsSubmitting(true);
                          formSubmit();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                  {isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setIsSubmitting(false)}
                      >
                        Regain Submit
                      </button>
                    </div>
                  )}
                  {showPagination === true && (
                    <div className="col-lg-5 mt-4">{renderPagination()}</div>
                  )}
                </>
              )}
            </div>

            {/* Item List */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row mt-3">
                  {showPagination && list.length > 0 && renderPagination()}
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">
                        Items in the Production
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg">
                    <table
                      className="table table-sm"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <thead
                        className="fixed-header"
                        style={{
                          position: "sticky",
                          top: "35%",
                          width: "104%",
                          marginBottom: "10px",
                          zIndex: "1000",
                          backgroundColor: "white",
                          transition: "all 0.3s ease-in-out",
                          transform: "translateY(0)",
                        }}
                      >
                        <tr>
                          <th>Product</th>
                          <th>Shape</th>
                          <th>Planning</th>
                          {/* <th>Planning Qty</th> */}
                          <th>Glost Weight</th>
                          {/* <th>Opening Balance</th> */}
                          {/* <th>Received</th>
                      <th>Total Selected</th> */}
                          {/* <th>Repair Qty</th>*/}
                          {/* <th>Total Received Qty</th> */}
                          <th>Available</th>
                          <th>Export Class</th>
                          <th>A Class</th>
                          <th>B Class</th>
                          <th>C Class</th>
                          <th>Total Select</th>
                          <th>Select</th>
                          <th>Defects</th>
                          <th>Total Repair</th>
                          <th>Repair</th>
                          {/* <th>Total Produced</th> */}
                          {/* <th>Weight</th> */}
                          {/* <th>Production Qty</th> opening + rcved   */}
                          {/* <th>Transfered</th> */}
                          {/* <th>Transfer</th> */}
                          {/* <th>Loss Qty</th> */}
                          {/* <th>Closing Balance</th> total p - total t */}
                        </tr>
                      </thead>
                      <tbody>
                        {list.length < 1 ? (
                          <tr>
                            <td colSpan={16} className="text-center">
                              <ProgressSpinner />
                            </td>
                          </tr>
                        ) : (
                          list.map((item, index) => {
                            const rowKey = item?.id ?? index;
                            const rowStatusClass =
                              Number(item?.total_transfer_qty) >
                              Number(item?.planning_qty)
                                ? "bg-warning"
                                : Number(item?.total_transfer_qty) ==
                                    Number(item?.planning_qty)
                                  ? "bg-success  text-white"
                                  : "";

                            return (
                              <tr
                                key={index}
                                {...getRowProps(rowKey, rowStatusClass)}
                                style={{
                                  fontStyle:
                                    item?.status === "on_test"
                                      ? "italic"
                                      : undefined,
                                  fontWeight:
                                    item?.status === "on_test"
                                      ? "700"
                                      : undefined,
                                  border:
                                    item?.status === "on_test"
                                      ? "2px solid rgb(0, 89, 119)"
                                      : undefined,
                                }}
                              >
                                {/* <td>
                            {item.product_name} ({item.shape}) || {item.company}{" "}
                            #{item.production_work_order}
                            <br />
                            <b>Planning Qty:</b> {item.qty || 0} <br />{" "}
                            <b>Received Qty:</b> {item.total_received_qty || 0}{" "}
                            || <b>Total Selected Qty:</b>{" "}
                            {item.total_selcted_qty || 0}
                            <br />
                            <b>Repair Qty: </b> {item.total_repair_qty || 0} ||{" "}
                            <b>Transfered Qty: </b>{" "}
                            {item.total_transfer_qty || 0}
                          </td> */}
                                {/* <td>{item.qty}</td> */}

                                {/* <td>{item.opening_balance}</td> */}
                                {/* <td>{item.total_received_qty || 0}</td>
                          <td>{item.total_selcted_qty || 0}</td> */}
                                {/* <td>{item.total_repair_qty || 0}</td>
                          <td>{item.total_transfer_qty || 0}</td> */}
                                <td>
                                  {item.product_name} <br />
                                  <b>Glaze: {item.glaze_color_name || "N/A"}</b>
                                  {/* <b>Planning Qty:</b> {item.planning_qty} ||{" "} */}
                                  {/* <b>Total Produced:</b> {item.total_production_qty}{" "} */}
                                  <br />
                                  {/* <b>Decoration Code:</b>{" "} */}
                                  {/* {item.decoration_code || "N/A"} ||{" "} */}
                                  {/* <b>Decoration Name:</b>{" "} */}
                                  {/* {item.decoration_name || "N/A"} */}
                                </td>
                                <td> {item.shape}</td>
                                <td>
                                  {" "}
                                  {item.company}
                                  <strong>
                                    {" "}
                                    #{item.production_work_order}
                                  </strong>{" "}
                                  <br /> Planning: {item.qty} &nbsp; Received:{" "}
                                  {item.total_received_qty}{" "}
                                </td>
                                {/* <td>{item.qty}</td> */}
                                <td>
                                  <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      ))
                                    }
                                    className="form-control"
                                    name="glost_weight"
                                    value={item.glost_weight || ""}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                  />
                                </td>
                                {/* <td> {item.total_received_qty || 0}</td> */}
                                <td>{item.available_qty || 0}</td>
                                <td>
                                  <div className="d-flex">
                                    <input
                                      type="text"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      className="form-control me-2"
                                      name="qty_export"
                                      value={item.qty_export}
                                      onChange={(e) =>
                                        handleInputChange(e, index)
                                      }
                                    />
                                    {/* <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ))
                                    }
                                    className="form-control"
                                    name="after_production_loss_qty_export"
                                    value={
                                      item.after_production_loss_qty_export ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Loss Export"
                                  /> */}
                                  </div>
                                  <div className="mt-1">
                                    <small className="text-muted">
                                      Current:{" "}
                                      {(Number(
                                        item.current_stock_qty_export_class,
                                      ) || 0) + (Number(item.qty_export) || 0)}
                                    </small>
                                  </div>
                                  {/* <input
                                  type="text"
                                  className="form-control"
                                  name="remarks_export"
                                  value={item.remarks_export || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                /> */}
                                </td>
                                <td>
                                  <div className="d-flex">
                                    <input
                                      type="text"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      className="form-control me-2"
                                      name="qty_a_class"
                                      value={item.qty_a_class}
                                      onChange={(e) =>
                                        handleInputChange(e, index)
                                      }
                                    />
                                    {/* <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ))
                                    }
                                    className="form-control"
                                    name="after_production_loss_qty_a_class"
                                    value={
                                      item.after_production_loss_qty_a_class ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Loss A Class"
                                  /> */}
                                  </div>
                                  <div className="mt-1">
                                    <small className="text-muted">
                                      Current:{" "}
                                      {(Number(
                                        item.current_stock_qty_a_class,
                                      ) || 0) + (Number(item.qty_a_class) || 0)}
                                    </small>
                                  </div>
                                  {/* <input
                                  type="text"
                                  className="form-control"
                                  name="remarks_a"
                                  value={item.remarks_a || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                /> */}
                                </td>
                                <td>
                                  <div className="d-flex">
                                    <input
                                      type="text"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      className="form-control me-2"
                                      name="qty_b_class"
                                      value={item.qty_b_class}
                                      onChange={(e) =>
                                        handleInputChange(e, index)
                                      }
                                    />
                                    {/* <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ))
                                    }
                                    className="form-control"
                                    name="after_production_loss_qty_b_class"
                                    value={
                                      item.after_production_loss_qty_b_class ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Loss B Class"
                                  /> */}
                                  </div>
                                  <div className="mt-1">
                                    <small className="text-muted">
                                      Current:{" "}
                                      {(Number(
                                        item.current_stock_qty_b_class,
                                      ) || 0) + (Number(item.qty_b_class) || 0)}
                                    </small>
                                  </div>
                                  {/* <input
                                  type="text"
                                  className="form-control"
                                  name="remarks_b"
                                  value={item.remarks_b || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                /> */}
                                </td>
                                <td>
                                  <div className="d-flex">
                                    <input
                                      type="text"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      className="form-control me-2"
                                      name="qty_c_class"
                                      value={item.qty_c_class}
                                      readOnly
                                    />
                                    {/* <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ))
                                    }
                                    className="form-control"
                                    name="after_production_loss_qty_c_class"
                                    value={
                                      item.after_production_loss_qty_c_class ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Loss C Class"
                                  /> */}
                                  </div>
                                  <div className="mt-1">
                                    <small className="text-muted">
                                      Current:{" "}
                                      {(Number(
                                        item.current_stock_qty_c_class,
                                      ) || 0) + (Number(item.qty_c_class) || 0)}
                                    </small>
                                  </div>
                                  {/* <input
                                  type="text"
                                  className="form-control"
                                  name="remarks_c"
                                  value={item.remarks_c || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                /> */}
                                </td>
                                <td>{item.total_selcted_qty}</td>
                                <td>{item.select_qty || 0}</td>

                                <td>
                                  <div className="text-center mb-2">
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        handleAddType(index, "defect")
                                      }
                                    >
                                      <i className="fa fa-plus"></i>
                                    </button>
                                  </div>
                                  {(item.defect_items || []).map(
                                    (defect, subIndex) => (
                                      <div
                                        key={subIndex}
                                        className="d-flex align-items-center mb-2"
                                      >
                                        <select
                                          className="form-control"
                                          value={defect.type}
                                          onChange={(e) =>
                                            handleTypeChange(
                                              index,
                                              subIndex,
                                              e.target.value,
                                              "defect",
                                            )
                                          }
                                        >
                                          <option value="">
                                            Select Defect Type
                                          </option>
                                          {defectTypes.map((type) => (
                                            <option key={type} value={type}>
                                              {type}
                                            </option>
                                          ))}
                                        </select>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control mx-2"
                                          name="defect_qty"
                                          value={defect.qty}
                                          onChange={(e) =>
                                            handleQtyChange(
                                              index,
                                              subIndex,
                                              e.target.value,
                                              "defect",
                                            )
                                          }
                                          placeholder="Qty"
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleRemoveType(
                                              index,
                                              subIndex,
                                              "defect",
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    ),
                                  )}
                                </td>

                                {/* Repairs column */}
                                <td> {item.total_repair_qty || 0} </td>
                                <td>
                                  <div className="text-center mb-2">
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        handleAddType(index, "repair")
                                      }
                                    >
                                      <i className="fa fa-plus"></i>
                                    </button>
                                  </div>
                                  {(item.repair_items || []).map(
                                    (repair, subIndex) => (
                                      <div
                                        key={subIndex}
                                        className="d-flex align-items-center mb-2"
                                      >
                                        <select
                                          className="form-control"
                                          value={repair.type}
                                          onChange={(e) =>
                                            handleTypeChange(
                                              index,
                                              subIndex,
                                              e.target.value,
                                              "repair",
                                            )
                                          }
                                        >
                                          <option value="">
                                            Select Repair Type
                                          </option>
                                          {repairTypes.map((type) => (
                                            <option key={type} value={type}>
                                              {type}
                                            </option>
                                          ))}
                                        </select>
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control mx-2"
                                          name="repair_qty"
                                          value={repair.qty}
                                          onChange={(e) =>
                                            handleQtyChange(
                                              index,
                                              subIndex,
                                              e.target.value,
                                              "repair",
                                            )
                                          }
                                          placeholder="Qty"
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            handleRemoveType(
                                              index,
                                              subIndex,
                                              "repair",
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    ),
                                  )}
                                </td>
                                {/* <td>578</td> */}
                                {/* <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="weight"
                              value={item.weight}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td> */}
                                {/* <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="production_qty"
                              value={inputs.production_qty || 0}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td> */}
                                {/* <td>350</td> */}
                                {/* <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="transfer_qty"
                              value={item.transfer_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="return_qty"
                              value={item.return_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td> */}
                                {/* <td>{item.closing_balance}</td> */}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    {showPagination && list.length > 0 && renderPagination()}
                  </div>
                </div>
              </>
            )}

            {/* {list.length > 0 && (
              <div className="row mt-3">
                <div className="col-3">
                  <button className="btn btn-primary" onClick={formSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
